import axios from 'axios';
import {
    CheckOutQuestion,
    CheckOutQuestionResult
} from '../models/check-out-question';

export const getCheckOutQuestions = async (appointmentId: number): Promise<Undefinable<CheckOutQuestion[]>> => {
    const response = await axios.get(`/api/check-out-question/appointment/${appointmentId}`);
    return response.data;
};

export const createCheckOutQuestion = async (checkOutQuestion: CheckOutQuestion): Promise<CheckOutQuestionResult> => {
    const response = await axios.post(`/api/check-out-question`, checkOutQuestion);
    return response.data;
};

export const updateCheckOutQuestion = async (checkOutQuestion: CheckOutQuestion): Promise<CheckOutQuestionResult> => {
    const response = await axios.put(`/api/check-out-question`, checkOutQuestion);
    return response.data;
};
